import React, { useLayoutEffect } from "react";

import Footer from "../components/footer/footer";
import SathyaSaiMenu from "../components/navbarmenu/navmenu";
import Banner from "../components/banner/banner";
import SaiService from "../components/saiservice/saiservice";
import SSCMKESchedule from "../components/eventschedule/eventschedule";
import ServiceFAQ  from "../components/servicefaq/servicefaq";
import BottomBanner from "../components/bottombanner/bottombanner";
import Menucardforallpage from "../components/menucardforallpage/menucardforallpage";
import QuoteBanner from "../components/quotebanner/quotebanner";
import YoutubeEmbed from "../components/YoutubeEmbed/YoutubeEmbed";
import ArtclesView from "../components/articlesview/articlesview";

function SaiServicePage() {
    useLayoutEffect(() => {
     document.title = 'Selfless Service - Sri Sathya Sai Center of Milwaukee | ssscmke.org';
    }, []);
  return (
    <div className="SSE">
        <SathyaSaiMenu />
        <Banner title="Sai Service" pic="/images/Service.jpg" />
        <QuoteBanner />
        <SSCMKESchedule />
        {/* <div class="marquee-container">
          <div class="marquee-track">
            <h3 style={{ textAlign: 'center' }}>Register for FREE Web Coding Classes this July & August! by filling out the form below</h3>
          </div>
        </div> */}
        <SaiService />
        <ArtclesView />
        <Menucardforallpage page="service" />
        <ServiceFAQ />
        <div
          className="cs-two-column"
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '1rem',
            alignItems: 'start',
            width: '100%'
          }}
          >
          <div>
            <YoutubeEmbed embedId="https://www.youtube.com/embed/9OX63nwx3Q8?si=5xDsnCKwYEksCOIn"/>
          </div>
          <div>
            <YoutubeEmbed embedId="https://www.youtube.com/embed/1SZBCSIau9A?si=5xDsnCKwYEksCOIn"/>
          </div>
        </div>
        <BottomBanner />
        <Footer />
    </div>
  );
}
export default SaiServicePage;
